export const upcomingMeetingRegistrationStatuses = [
    'PENDING',
    'INVITED',
    'REGISTERED',
    'ACTIVE',
];
export const pastMeetingRegistrationStatuses = [
    'ATTENDED',
    'DECLINED',
    'NO_SHOW',
];
export const upcomingAndPastMeetingRegistrationStatuses = [
    ...upcomingMeetingRegistrationStatuses,
    ...pastMeetingRegistrationStatuses,
];
export const upcomingMeetingStatuses = [
    'PRE_MEETING',
    'ACTIVE',
];
export const pastMeetingStatuses = [
    'POST_MEETING',
];
export const upcomingAndPastMeetingStatuses = [
    ...upcomingMeetingStatuses,
    ...pastMeetingStatuses,
];
const MEETING_REGISTRATION_STATUS = {
    upcoming: upcomingMeetingRegistrationStatuses,
    past: pastMeetingRegistrationStatuses,
    both: upcomingAndPastMeetingRegistrationStatuses,
};
const MEETING_STATUS = {
    upcoming: upcomingMeetingStatuses,
    past: pastMeetingStatuses,
    both: upcomingAndPastMeetingStatuses,
};
export const getMeetingRegistrationStatusFilter = (statusOption) => {
    const statuses = MEETING_REGISTRATION_STATUS[statusOption] || upcomingMeetingRegistrationStatuses;
    return {
        or: statuses.map((status) => ({ status: { eq: status } })),
    };
};
export const getMeetingStatusFilter = (statusOption) => {
    const statuses = MEETING_STATUS[statusOption];
    return {
        or: statuses.map((status) => ({ status: { eq: status } })),
    };
};
export const getMeetingAccessFilter = (customer, customerAccessGroups, accessOption) => {
    switch (accessOption) {
        case 'registered':
            return {
                registered: { eq: true },
            };
        case 'invited':
            return {
                invited: { eq: true },
            };
        case 'registeredOrInvited':
            return {
                or: [
                    { registered: { eq: true } },
                    { invited: { eq: true } },
                ],
            };
        case 'hasAccess': {
            const customerAccessFilter = customerAccessGroups.length > 0
                ? {
                    or: customerAccessGroups.map((customerAccessGroup) => ({
                        accessGroups: { match: customerAccessGroup },
                    })),
                }
                : null;
            return {
                or: [
                    {
                        and: [
                            { restrictByAccessGroup: { eq: false } },
                            { restrictByCustomer: { eq: false } },
                        ],
                    },
                    // or restricted by access group and has access group
                    customerAccessFilter
                        ? {
                            and: [
                                { restrictByAccessGroup: { eq: true } },
                                customerAccessFilter,
                            ],
                        }
                        : null,
                    // or restricted by customer and has customer
                    (customer?.id ? {
                        and: [
                            { customers: { match: customer.id } },
                            { restrictByCustomer: { eq: true } },
                        ],
                    } : null),
                ].filter(Boolean),
            };
        }
        // case 'membership':
        //   return {
        //     or: [
        //       ...(customerAccessGroups.map((customerAccessGroup:string) => (
        //         { accessGroups: { match: customerAccessGroup } }
        //       ))),
        //     ],
        //   };
        default:
            return {};
    }
};
export const getMeetingSearchFilter = (statusOption, currentCustomer, currentAccess, accessOption) => {
    const searchFilter = {
        and: [
            getMeetingStatusFilter(statusOption),
            getMeetingAccessFilter(currentCustomer, currentAccess?.groups || [], accessOption),
        ],
    };
    console.log('searchFilter', searchFilter);
    return searchFilter;
};
//# sourceMappingURL=meetingHelpers.js.map